import http from '@/utils/http/index';

export const queryCardSortList = (params) => http.get('/merchant/cardSort/pageList', { params });

export const queryCardSortDetail = (params) => http.get('/merchant/cardSort/details', { params });

export const addCardSortInfo = (data) => http.post('/merchant/cardSort/add', data);

export const updateCardSortInfo = (data) => http.post('/merchant/cardSort/update', data);

export const querySortCardTypeList = (params) => http.get('/merchant/cardSort/cardTypeList', { params });

export const deleteByCountry = (data) => http.post('/merchant/cardSort/deleteByCountry', data);
